module.exports = __webpack_public_path__ + "media/images/home/security-3-ea59eea64b8dca113475fd0cef83a3e2.png";